<template>
  <ValidationProvider
    v-slot="validationContext"
    :name="content.libAireTexte"
    :rules="'required' + (content.maxCaractere ? `|max:${content.maxCaractere}` : '')"
    class="w-100"
    tag="div"
  >
    <b-form-group>
      <label :for="content.inputNameAireTexte ? content.inputNameAireTexte : 'aireTexte'">
        {{ content.libAireTexte }}
      </label>
      <textarea
        :id="'aire-texte-' + uid"
        v-model="aireTexte"
        class="aire-texte w-100 mb-n1"
        :name="content.inputNameAireTexte ? content.inputNameAireTexte : 'aireTexte'"
        :rows="content.nbLignes"
        :state="getValidationState(validationContext)"
      />
      <div class="d-inline-flex w-100">
        <ErreurValidation
          id="aire-texte-live-feedback"
          :message="validationContext.errors[0]"
          :variables="variablesARemplacer"
        />
        <div v-if="content.maxCaractere" class="max-caracteres">
          <span>
            {{ getTexteCaractereRestant() }}
          </span>
        </div>
      </div>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import ErreurValidation from '@/components/formulaire/compte/ErreurValidation';

export default {
  name: 'AireTexte',
  components: { ErreurValidation },
  props: { content: { type: Object, required: true } },
  data() {
    return {
      valeurAireTexte: '',
      variablesARemplacer: {
        maxLength: this.content.maxCaractere,
      },
    };
  },
  computed: {
    aireTexte: {
      get() {
        return this.valeurAireTexte;
      },
      set(value) {
        this.valeurAireTexte = value;
        this.$emit('input', this.valeurAireTexte);
      },
    },
  },
  mounted() {
    if (this.content.maxCaractere) {
      document
        .getElementById(`aire-texte-${this.uid}`)
        .setAttribute('maxlength', this.content.maxCaractere);
    }
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      // Uniquement si la validation a été effectuée une fois et que le champ est invalide
      if (validated && !valid) {
        return valid;
      }
      return null;
    },
    getTexteCaractereRestant() {
      return this.content.libMaxCaractere
        ? this.content.libMaxCaractere.replace(
            `{{maxCaracteres}}`,
            parseInt(this.content.maxCaractere, 10) - this.aireTexte.length
          )
        : this.content.maxCaractere;
    },
  },
};
</script>

<style lang="scss">
.aire-texte {
  background-color: $couleur-fond-primaire;
  border: 1px solid $couleur-primaire;
  border-radius: 0.25rem;
  color: $couleur-bleu-fonce-lq;
  &:focus {
    box-shadow: 0 0 0 0.075rem $couleur-primaire inset;
    --webkit-box-shadow: 0 0 0 0.075rem $couleur-primaire inset;
  }
}
.max-caracteres {
  text-align: right;
  margin-top: 0.75rem;
  margin-bottom: 0.5rem;
  font-size: 15px;
  width: 100%;
}
</style>
